import { render } from "./amlakMap.vue?vue&type=template&id=9bd8fbce&scoped=true"
import script from "./amlakMap.vue?vue&type=script&lang=js"
export * from "./amlakMap.vue?vue&type=script&lang=js"

import "./amlakMap.vue?vue&type=style&index=0&id=9bd8fbce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd8fbce"]])

export default __exports__